import { render, staticRenderFns } from "./ParaphIcon.vue?vue&type=template&id=63b52ea8"
import script from "./ParaphIcon.vue?vue&type=script&lang=js"
export * from "./ParaphIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports